import script from "./d3d-viewer.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./d3d-viewer.vue?vue&type=script&lang=ts&setup=true&async=true"

import "./d3d-viewer.vue?vue&type=style&index=0&id=1e72d2d0&lang=less"

const __exports__ = script;

export default __exports__